import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import s from './LargeSophisticatedTooltipHeading.scss';

interface Props extends HTMLAttributes<HTMLSpanElement> {}

const LargeSophisticatedTooltipHeading: React.FC<Props> = ({
  children,
  className,
  ...rest
}) => (
  <span className={c(s['root'], className)} {...rest}>
    {children}
  </span>
);
LargeSophisticatedTooltipHeading.displayName =
  'LargeSophisticatedTooltipHeading';

export default LargeSophisticatedTooltipHeading;
